/** Thin axios + Firebase-bearer wrappers for the two signature
 *  endpoints. Mirrors the pattern in
 *  ``entities/me/api/fetch-my-status.ts``.
 */

import axios from 'axios';

import { createLotusRequestConfig } from '@/shared/api/lotus/client';

import type { ClinicianSignatureT, SignatureUploadT } from './signatureTypes';

const BASE_PATH = '/greenfield/clinician/me/signature';

/** Returns ``null`` when the clinician hasn't uploaded a signature
 *  yet. The endpoint encodes absence as ``200 OK`` with a ``null``
 *  body (see the impl docstring), so we read it straight off the
 *  response and let any non-2xx propagate as a real error. */
export async function fetchMySignature(signal?: AbortSignal): Promise<ClinicianSignatureT | null> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.get<ClinicianSignatureT | null>(
    `${config.baseURL}${BASE_PATH}`,
    config
  );
  return response.data;
}

export async function postSignatureUpload(
  body: SignatureUploadT,
  signal?: AbortSignal
): Promise<ClinicianSignatureT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await axios.post<ClinicianSignatureT>(
    `${config.baseURL}${BASE_PATH}/upload`,
    body,
    config
  );
  return response.data;
}
